import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class SortTableHeader extends Vue {
    @Prop() label!: any
    @Prop() value!: any

    get observationSort() {
        return this.$store.getters.observationSort
    }

    sortColumn() {
        let num = (this.index + 1) % this.states.length
        let val = this.states[num]
        let obj = JSON.parse(JSON.stringify(this.observationSort))
        obj[this.value] = val
        this.$store.commit('observationSort', obj)
    }

    get sortBy() {
        return this.$store.getters.observationSort[this.value]
    }

    get states() {
        return [null, this.value, `-${this.value}`]
    }

    get index() {
        return this.states.findIndex((item: any) => item == this.sortBy)
    }
}
